import type { Node } from '@xyflow/react';

export type WorkflowFlowManualPosition = {
  x: number;
  y: number;
};

export type WorkflowFlowManualPositions = Map<
  string,
  WorkflowFlowManualPosition
>;

export function applyWorkflowFlowManualPositions<N extends Node>(
  nodes: N[],
  manualPositions: WorkflowFlowManualPositions
): N[] {
  if (manualPositions.size === 0) {
    return nodes;
  }
  return nodes.map((node) => {
    const manual = manualPositions.get(node.id);
    if (manual === undefined) {
      return node;
    }
    return {
      ...node,
      position: manual,
    };
  });
}
